import React from "react";
import { useLanguage } from "@/context/LanguageContext";

// Google Play Store button — replica of the official badge styling.
// The href is configurable; default points to the app's Play Store URL.
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.vetriguide.app";

const PlayStoreButton = ({
  size = "lg",
  variant = "dark",
  testId = "cta-playstore",
  className = "",
  href,
}) => {
  const { t } = useLanguage();
  const isDark = variant === "dark";
  const sizes = {
    sm: "px-4 py-2 text-sm gap-2",
    md: "px-5 py-3 text-base gap-2.5",
    lg: "px-6 py-3.5 text-base gap-3",
    xl: "px-7 py-4 text-lg gap-3",
  };
  return (
    <a
      href={href || PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label="Download TNPSC Tamil on Google Play"
      className={`btn-shine inline-flex items-center rounded-2xl font-semibold transition-all hover:-translate-y-0.5 active:translate-y-0 ${
        isDark
          ? "bg-slate-900 text-white hover:bg-slate-800 shadow-lg shadow-slate-900/20"
          : "bg-white text-slate-900 border border-slate-200 hover:border-slate-300 shadow"
      } ${sizes[size]} ${className}`}
    >
      {/* Google Play multi-color icon */}
      <svg
        viewBox="0 0 24 24"
        className={`shrink-0 ${
          size === "sm" ? "h-5 w-5" : size === "xl" ? "h-8 w-8" : "h-7 w-7"
        }`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.6 1.7a1.5 1.5 0 0 0-.6 1.2v18.2c0 .5.2.9.6 1.2L13.2 12 3.6 1.7z"
          fill="#34A853"
        />
        <path
          d="M16.8 8.5 13.2 12l3.6 3.5 4.2-2.4c1-.6 1-2.1 0-2.7L16.8 8.5z"
          fill="#FBBC04"
        />
        <path
          d="M3.6 22.3c.3.2.7.3 1.1.1l12.1-6.9-3.6-3.5L3.6 22.3z"
          fill="#EA4335"
        />
        <path
          d="M3.6 1.7 13.2 12l3.6-3.5L4.7 1.6c-.4-.2-.8-.1-1.1.1z"
          fill="#4285F4"
        />
      </svg>
      <span className="flex flex-col items-start leading-tight">
        <span
          className={`text-[10px] tracking-wider uppercase font-semibold ${
            isDark ? "text-slate-300" : "text-slate-500"
          }`}
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          {t.common.downloadPlayStoreSub}
        </span>
        <span
          className="font-bold"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          {t.common.downloadPlayStore}
        </span>
      </span>
    </a>
  );
};

export default PlayStoreButton;
